<demooz-modal-media #modalMedia />

<div class="faq_details">
    
    <div class="faq_details_header">
        <div class="page_title_content">
            <div class="page_title">{{this.faq.title}}</div>   
            <div class="page_subtitle">{{this.faq.subtitle}}</div>
        </div>
    </div>
    
    <div class="faq_details_content">
        @if(this.faqMedia){
            <div class="faq_details_media">
                @switch(this.faqMedia.type){
                    @case('picture'){
                        <img [src]="this.faqMedia.src" (click)="this.showMedia()"/>
                    }
                    @case('video'){
                        <video [src]="this.faqMedia.src" controls></video>
                    }
                }
            </div>
        }
        
        <div class="faq_details_description" [innerHTML]="this.description"></div>
        
        @if(this.faq.buttonLink && this.faq.buttonLink != ''){
            <div class="faq_details_link">
                <demooz-button type="button" [label]="this.faq.button" (click)="this.openLinkFaq()"/>
            </div>
        }
        
    </div>
        
</div>